import {
  FormControlOverrides,
  FormControl as FormControlBase,
  FormControlProps,
} from 'baseui/form-control';

const overrides: FormControlOverrides = {
  ControlContainer: {
    style: () => ({
      marginBottom: '0',
    }),
  },
  Label: {
    style: ({ $theme }) => ({
      fontSize: $theme.sizing.scale500,
      color: $theme.colors.white,
      marginBottom: '0',
    }),
  },
};

export function FormControl(props: FormControlProps) {
  return <FormControlBase overrides={overrides} {...props} />;
}
